import { ResourceModel } from '../../resource-media-control/model/resource-media.model';

/**
 * Smart Tag Location consume 3 different Components
 */
export class SmartTagLocationFlow {
	step: SMART_TAG_LOCATION_STEP;
	resourceModel: ResourceModel;
	filterBy: any[];

	constructor() {
		this.step = SMART_TAG_LOCATION_STEP.LIST;
		this.resourceModel = new ResourceModel();
		this.filterBy = [];
	}
}

export enum SMART_TAG_LOCATION_STEP {
	PIN,
	EMPTY,
	CREATE,
	EDIT,
	LIST
}